import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import Header from 'containers/SignupPages/Header';
import { translate } from 'helpers/intl';
import messages from 'containers/SignupPages/IdMemo/messages';
import Form from 'containers/SignupPages/IdMemo/Form';
import { getEmailSelector, getLoginSelector } from 'store/user/selectors';

export type IdMemoType = {
  intl: IntlShape;
  setSignupStep: Function;
  email: string;
  onSubmitStep: Function;
  identifiant: string;
  isLoading: boolean;
};

const IdMemo = (props: IdMemoType) => (
  <React.Fragment>
    <Header
      title={translate({ ...messages.title }, props)}
      subTitle={translate({ ...messages.subTitle }, props)}
    />
    <Form
      identifiant={props.identifiant}
      email={props.email}
      onSubmitStep={props.onSubmitStep}
      onClickPrevious={props.setSignupStep}
      isLoading={props.isLoading}
    />
  </React.Fragment>
);

const mapStateToProps = createStructuredSelector<
  any,
  { email: string; identifiant: string }
>({
  email: getEmailSelector,
  identifiant: getLoginSelector,
});

export default connect(mapStateToProps)(injectIntl(IdMemo));
